import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "children", "image", "attachment", "clip", "origin", "position", "repeat", "size"];
import React from 'react';
import { getTextureStyles } from './Texture.utils';
import useSemanticUiProps from '../../../../modules/foundation/hooks/use-semantic-ui-props';
import { ChildrenPropType, ImagePropType } from '../../../../services/proptypes';
import GridColumnFlex from '../../../GridColumnFlex';
var defaultProps = {
  className: '',
  attachment: 'scroll',
  clip: 'border-box',
  origin: 'padding-box',
  position: '0% 0%',
  repeat: 'repeat',
  size: 'auto auto'
};
function Texture(_ref) {
  var className = _ref.className,
    children = _ref.children,
    image = _ref.image,
    attachment = _ref.attachment,
    clip = _ref.clip,
    origin = _ref.origin,
    position = _ref.position,
    repeat = _ref.repeat,
    size = _ref.size,
    columnProps = _objectWithoutProperties(_ref, _excluded);
  var classNames = "background-texture ".concat(className);
  var style = getTextureStyles({
    image: image,
    attachment: attachment,
    clip: clip,
    origin: origin,
    position: position,
    repeat: repeat,
    size: size
  });
  var _useSemanticUiProps = useSemanticUiProps(),
    getColumnProps = _useSemanticUiProps.getColumnProps;
  return /*#__PURE__*/React.createElement(GridColumnFlex, _extends({
    className: classNames,
    style: style
  }, getColumnProps(columnProps)), children);
}
Texture.defaultProps = defaultProps;
export default Texture;